// src/stores/themeStore.js
import { defineStore } from 'pinia'
import { useTheme } from 'vuetify'

export const useThemeStore = defineStore('theme', {
  state: () => ({
    isDark: false,
  }),
  actions: {
    initTheme() {
      const saved = localStorage.getItem('theme')
      this.isDark = saved === 'dark'
      useTheme().global.name.value = this.isDark ? 'dark' : 'light'
    },
    toggleTheme(value) {
      this.isDark = value
      localStorage.setItem('theme', value ? 'dark' : 'light')
      useTheme().global.name.value = value ? 'dark' : 'light'
    },
  },
})
